import { Stack, Text, Box, Divider, useMantineColorScheme } from "@mantine/core";


export function PrivacyPolicyContent() {
  const { colorScheme } = useMantineColorScheme();
  const textColor = colorScheme === "dark" ? "white" : "#393939";
  const headingColor = colorScheme === "dark" ? "white" : "#1D1D1D";
  
  return (
    <Stack gap={24} style={{ paddingRight: "16px" }}>
                {/* Last Updated and Description */}
                <Stack gap={8}>
                  <Box style={{ display: 'flex', alignItems: 'center', gap: 8, width: 226 }}>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 510,
                        fontSize: 14,
                        lineHeight: '1.2em',
                        color: '#979797',
                      }}
                    >
                      Last updated:
                    </Text>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 510,
                        fontSize: 16,
                        lineHeight: '1.2em',
                        color: textColor,
                      }}
                    >
                      January 26, 2021
                    </Text>
                  </Box>
                  <Text
                    style={{
                      fontFamily: 'SF Pro',
                      fontWeight: 400,
                      fontSize: 14,
                      lineHeight: '1.6em',
                      color: textColor,
                    }}
                  >
                    This Privacy Policy describes Our policies and procedures on the collection,
use and disclosure of Your information when You use the Service and tells You
about Your privacy rights and how the law protects You.

<br />
<br />
We use Your Personal data to provide and improve the Service. By using the
Service, You agree to the collection and use of information in accordance with
this Privacy Policy.                    </Text>
                </Stack>

                <Divider color="#E9E9E9" />

                {/* Privacy Policy Content */}
                <Stack gap={24}>
                  {/* Interpretation and Definitions */}
                  <Stack gap={16}>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 510,
                        fontSize: 16,
                        lineHeight: '1.2em',
                        color: headingColor,
                      }}
                    >
                      Interpretation and Definitions  

                    </Text>
                    
                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Interpretation
                        <br />
                        <br />
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        The words of which the initial letter is capitalized have meanings defined
under the following conditions. The following definitions shall have the same
meaning regardless of whether they appear in singular or in plural.
                      </Text>
                    </Stack>

                    <Stack gap={12}>
                      <Stack gap={8}>
                        <Text
                          style={{
                            fontFamily: 'SF Pro',
                            fontWeight: 510,
                            fontSize: 16,
                            lineHeight: '1.2em',
                            color: headingColor,
                          }}
                        >
                          Definitions
                          <br />
                          <br />
                        </Text>
                        <Text
                          style={{
                            fontFamily: 'SF Pro',
                            fontWeight: 400,
                            fontSize: 14,
                            lineHeight: '1.2em',
                            color: textColor,
                          }}
                        >
                          For the purposes of this Privacy Policy:
                        </Text>
                      </Stack>
                      
                      <Stack gap={8}>
                        <Text
                          style={{
                            fontFamily: 'SF Pro',
                            fontWeight: 400,
                            fontSize: 14,
                            lineHeight: '1.6em',
                            color: textColor,
                          }}
                        >
                           * Account means a unique account created for You to access our Service or
  parts of our Service.
<br />
<br />
* Affiliate means an entity that controls, is controlled by or is under
  common control with a party, where "control" means ownership of 50% or
  more of the shares, equity interest or other securities entitled to vote
  for election of directors or other managing authority.
<br />
<br />
* Application means the software program provided by the Company downloaded
  by You on any electronic device, named Virtual Me
<br />
<br />
* Business , for the purpose of the CCPA (California Consumer Privacy Act),
  refers to the Company as the legal entity that collects Consumers'
  personal information and determines the purposes and means of the
  processing of Consumers' personal information, or on behalf of which such
  information is collected and that alone, or jointly with others,
  determines the purposes and means of the processing of consumers' personal
  information, that does business in the State of California.
<br />
<br />
* Company (referred to as either "the Company", "We", "Us" or "Our" in this
  Agreement) refers to OneSelf LLC, 14355 McKenna Road NW, Prior Lake, MN
  55372.
<br />
<br />
  For the purpose of the GDPR, the Company is the Data Controller.
<br />
<br />
* Consumer , for the purpose of the CCPA (California Consumer Privacy Act),
  means a natural person who is a California resident. A resident, as
  defined in the law, includes (1) every individual who is in the USA for
  other than a temporary or transitory purpose, and (2) every individual who
  is domiciled in the USA who is outside the USA for a temporary or
  transitory purpose.
<br />
<br />
* Country refers to: Minnesota, United States
<br />
<br />
* Data Controller , for the purposes of the GDPR (General Data Protection
  Regulation), refers to the Company as the legal person which alone or
  jointly with others determines the purposes and means of the processing of
  Personal Data.
<br />
<br />
* Device means any device that can access the Service such as a computer, a
  cellphone or a digital tablet.
<br />
<br />
* Do Not Track (DNT) is a concept that has been promoted by US regulatory
  authorities, in particular the U.S. Federal Trade Commission (FTC), for
  the Internet industry to develop and implement a mechanism for allowing
  internet users to control the tracking of their online activities across
  websites.
<br />
<br />
* Personal Data is any information that relates to an identified or
  identifiable individual.
<br />
<br />
  For the purposes for GDPR, Personal Data means any information relating to
  You such as a name, an identification number, location data, online
  identifier or to one or more factors specific to the physical,
  physiological, genetic, mental, economic, cultural or social identity.
<br />
<br />
  For the purposes of the CCPA, Personal Data means any information that
  identifies, relates to, describes or is capable of being associated with,
  or could reasonably be linked, directly or indirectly, with You.
<br />
<br />
* Sale , for the purpose of the CCPA (California Consumer Privacy Act),
  means selling, renting, releasing, disclosing, disseminating, making
  available, transferring, or otherwise communicating orally, in writing, or
  by electronic or other means, a Consumer's personal information to another
  business or a third party for monetary or other valuable consideration.
<br />
<br />
* Service refers to the Application.
<br />
<br />
* Service Provider means any natural or legal person who processes the data
  on behalf of the Company. It refers to third-party companies or
  individuals employed by the Company to facilitate the Service, to provide
  the Service on behalf of the Company, to perform services related to the
  Service or to assist the Company in analyzing how the Service is used. For
  the purpose of the GDPR, Service Providers are considered Data Processors.
<br />
<br />
* Third-party Social Media Service refers to any website or any social
  network website through which a User can log in or create an account to
  use the Service.
<br />
<br />
* Usage Data refers to data collected automatically, either generated by the
  use of the Service or from the Service infrastructure itself (for example,
  the duration of a page visit).
<br />
<br />
* You means the individual accessing or using the Service, or the company,
  or other legal entity on behalf of which such individual is accessing or
  using the Service, as applicable.
<br />
<br />  
  Under GDPR (General Data Protection Regulation), You can be referred to as
  the Data Subject or as the User as you are the individual using the
  Service.
<br />
                        </Text>
                        
                      </Stack>
                    </Stack>
                  </Stack>

                  {/* Collecting and Using Your Personal Data */}
                  <Stack gap={16}>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 510,
                        fontSize: 18,
                        lineHeight: '1.2em',
                        color: headingColor,
                      }}
                    >
                      Collecting and Using Your Personal Data
                    </Text>

                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 510,
                        fontSize: 16,
                        lineHeight: '1.2em',
                        color: headingColor,
                      }}
                    >
                      Types of Data Collected
                    </Text>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Personal Data
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        While using Our Service, We may ask You to provide Us with certain personally
identifiable information that can be used to contact or identify You.
Personally identifiable information may include, but is not limited to:
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        * Email address
                        <br />

* First name and last name
<br />

* Phone number
<br />
* Address, State, Province, ZIP/Postal code, City
<br />
* Usage Data
<br />
                      </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Usage Data
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        Usage Data is collected automatically when using the Service.
                        <br />
                        <br />

Usage Data may include information such as Your Device's Internet Protocol
address (e.g. IP address), browser type, browser version, the pages of our
Service that You visit, the time and date of Your visit, the time spent on
those pages, unique device identifiers and other diagnostic data.
<br />
<br />

When You access the Service by or through a mobile device, We may collect
certain information automatically, including, but not limited to, the type of
mobile device You use, Your mobile device unique ID, the IP address of Your
mobile device, Your mobile operating system, the type of mobile Internet
browser You use, unique device identifiers and other diagnostic data.
<br />
<br />
We may also collect information that Your browser sends whenever You visit our
Service or when You access the Service by or through a mobile device.
<br />
<br />
                      </Text>
                     
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Information Collected while Using the Application
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        While using Our Application, in order to provide features of Our Application,
We may collect, with Your prior permission:
<br />
<br />
* Information regarding your location
<br />
<br />
We use this information to provide features of Our Service, to improve and
customize Our Service. The information may be uploaded to the Company's
servers and/or a Service Provider's server or it may be simply stored on Your
device.
<br />
<br />
You can enable or disable access to this information at any time, through Your
Device settings.
<br />
<br />
                      </Text>
                      
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Use of Your Personal Data
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        The Company may use Personal Data for the following purposes:
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                       * To provide and maintain our Service , including to monitor the usage of
  our Service.
<br />
<br />
* To manage Your Account: to manage Your registration as a user of the
  Service. The Personal Data You provide can give You access to different
  functionalities of the Service that are available to You as a registered
  user.
<br />
<br />
* For the performance of a contract: the development, compliance and
  undertaking of the purchase contract for the products, items or services
  You have purchased or of any other contract with Us through the Service.
<br />
<br />
* To contact You: To contact You by email, telephone calls, SMS, or other
  equivalent forms of electronic communication, such as a mobile
  application's push notifications regarding updates or informative
  communications related to the functionalities, products or contracted
  services, including the security updates, when necessary or reasonable for
  their implementation.
<br />
<br />
* To provide You with news, special offers and general information about
  other goods, services and events which we offer that are similar to those
  that you have already purchased or enquired about unless You have opted
  not to receive such information.
<br />
<br />
* To manage Your requests: To attend and manage Your requests to Us.
<br />
<br />
* For business transfers: We may use Your information to evaluate or conduct
  a merger, divestiture, restructuring, reorganization, dissolution, or
  other sale or transfer of some or all of Our assets, whether as a going
  concern or as part of bankruptcy, liquidation, or similar proceeding, in
  which Personal Data held by Us about our Service users is among the assets
  transferred.
<br />
<br />
* For other purposes : We may use Your information for other purposes, such
  as data analysis, identifying usage trends, determining the effectiveness
  of our promotional campaigns and to evaluate and improve our Service,
  products, services, marketing and your experience.
<br />
<br />
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        We may share Your personal information in the following situations:
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                         * With Service Providers: We may share Your personal information with
  Service Providers to monitor and analyze the use of our Service, to
  contact You.
<br />
<br />
* For business transfers: We may share or transfer Your personal information
  in connection with, or during negotiations of, any merger, sale of Company
  assets, financing, or acquisition of all or a portion of Our business to
  another company.
<br />
<br />
* With Affiliates: We may share Your information with Our affiliates, in
  which case we will require those affiliates to honor this Privacy Policy.
  Affiliates include Our parent company and any other subsidiaries, joint
  venture partners or other companies that We control or that are under
  common control with Us.
<br />
<br />
* With business partners: We may share Your information with Our business
  partners to offer You certain products, services or promotions.
<br />
<br />
* With other users: when You share personal information or otherwise
  interact in the public areas with other users, such information may be
  viewed by all users and may be publicly distributed outside. If You
  interact with other users or register through a Third-Party Social Media
  Service, Your contacts on the Third-Party Social Media Service may see
  Your name, profile, pictures and description of Your activity. Similarly,
  other users will be able to view descriptions of Your activity,
  communicate with You and view Your profile.
<br />
<br />
* With Your consent : We may disclose Your personal information for any
  other purpose with Your consent.
<br />
<br />
                      </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Retention of Your Personal Data
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >                        </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        The Company will retain Your Personal Data only for as long as is necessary
for the purposes set out in this Privacy Policy. We will retain and use Your
Personal Data to the extent necessary to comply with our legal obligations
(for example, if we are required to retain your data to comply with applicable
laws), resolve disputes, and enforce our legal agreements and policies.
<br />
<br />
The Company will also retain Usage Data for internal analysis purposes. Usage
Data is generally retained for a shorter period of time, except when this data
is used to strengthen the security or to improve the functionality of Our
Service, or We are legally obligated to retain this data for longer time
periods.
<br />
<br />
                      </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Transfer of Your Personal Data
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        Your information, including Personal Data, is processed at the Company's
operating offices and in any other places where the parties involved in the
processing are located. It means that this information may be transferred to â€”
and maintained on â€” computers located outside of Your state, province, country
or other governmental jurisdiction where the data protection laws may differ
than those from Your jurisdiction.
<br />
<br />
Your consent to this Privacy Policy followed by Your submission of such
information represents Your agreement to that transfer.
<br />
<br />
The Company will take all steps reasonably necessary to ensure that Your data
is treated securely and in accordance with this Privacy Policy and no transfer
of Your Personal Data will take place to an organization or a country unless
there are adequate controls in place including the security of Your data and
other personal information.
<br />
<br />
                      </Text>
                      
                    </Stack>
                  </Stack>

                  {/* Disclosure of Your Personal Data */}
                  <Stack gap={16}>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 510,
                        fontSize: 18,
                        lineHeight: '1.2em',
                        color: headingColor,
                      }}
                    >
                      Disclosure of Your Personal Data
                    </Text>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Business Transactions
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        If the Company is involved in a merger, acquisition or asset sale, Your Personal Data may be transferred. We will provide notice before Your Personal Data is transferred and becomes subject to a different Privacy Policy.
                      </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Law enforcement
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).
                      </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Other legal requirements
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        * Comply with a legal obligation
<br />
* Protect and defend the rights or property of the Company
<br />
* Prevent or investigate possible wrongdoing in connection with the Service
<br />
* Protect the personal safety of Users of the Service or the public
<br />
* Protect against legal liability
<br />
                      </Text>
                    </Stack>
                  </Stack>

                  {/* Security of Your Personal Data */}
                  <Stack gap={16}>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 510,
                        fontSize: 18,
                        lineHeight: '1.2em',
                        color: headingColor,
                      }}
                    >
                      Security of Your Personal Data
                    </Text>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 400,
                        fontSize: 14,
                        lineHeight: '1.6em',
                        color: textColor,
                      }}
                    >
                      The security of Your Personal Data is important to Us, but remember that no
method of transmission over the Internet, or method of electronic storage is
100% secure. While We strive to use commercially acceptable means to protect
Your Personal Data, We cannot guarantee its absolute security.                      </Text>
                  </Stack>

                  {/* GDPR Privacy */}
                  <Stack gap={16}>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 510,
                        fontSize: 18,
                        lineHeight: '1.2em',
                        color: headingColor,
                      }}
                    >
                      GDPR Privacy
                    </Text>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Legal Basis for Processing Personal Data under GDPR
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        We may process Personal Data under the following conditions:
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        
* Consent: You have given Your consent for processing Personal Data for one
  or more specific purposes.
<br />
* Performance of a contract: Provision of Personal Data is necessary for the
  performance of an agreement with You and/or for any pre-contractual
  obligations thereof.
<br />
* Legal obligations: Processing Personal Data is necessary for compliance
  with a legal obligation to which the Company is subject.
<br />
* Vital interests: Processing Personal Data is necessary in order to protect
  Your vital interests or of another natural person.
<br />
* Public interests: Processing Personal Data is related to a task that is
  carried out in the public interest or in the exercise of official
  authority vested in the Company.
<br />
* Legitimate interests: Processing Personal Data is necessary for the
  purposes of the legitimate interests pursued by the Company.
<br />
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        In any case, the Company will gladly help to clarify the specific legal basis
that applies to the processing, and in particular whether the provision of
Personal Data is a statutory or contractual requirement, or a requirement
necessary to enter into a contract.
                      </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Your Rights under the GDPR
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        The Company undertakes to respect the confidentiality of Your Personal Data and to guarantee You can exercise Your rights.
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        You have the right under this Privacy Policy, and by law if You are within the EU, to:
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                          * Request access to Your Personal Data. The right to access, update or
  delete the information We have on You. Whenever made possible, you can
  access, update or request deletion of Your Personal Data directly within
  Your account settings section. If you are unable to perform these actions
  yourself, please contact Us to assist You. This also enables You to
  receive a copy of the Personal Data We hold about You.
<br />
* Request correction of the Personal Data that We hold about You. You have
  the right to to have any incomplete or inaccurate information We hold
  about You corrected.
<br />
* Object to processing of Your Personal Data. This right exists where We are
  relying on a legitimate interest as the legal basis for Our processing and
  there is something about Your particular situation, which makes You want
  to object to our processing of Your Personal Data on this ground. You also
  have the right to object where We are processing Your Personal Data for
  direct marketing purposes.
<br />
* Request erasure of Your Personal Data. You have the right to ask Us to
  delete or remove Personal Data when there is no good reason for Us to
  continue processing it.
<br />
* Request the transfer of Your Personal Data. We will provide to You, or to
  a third-party You have chosen, Your Personal Data in a structured,
  commonly used, machine-readable format. Please note that this right only
  applies to automated information which You initially provided consent for
  Us to use or where We used the information to perform a contract with You.
<br />
* Withdraw Your consent. You have the right to withdraw Your consent on
  using your Personal Data. If You withdraw Your consent, We may not be able
  to provide You with access to certain specific functionalities of the
  Service.
<br />
                      </Text>
                    </Stack>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 400,
                        fontSize: 14,
                        lineHeight: '1.6em',
                        color: textColor,
                      }}
                    >
                      Exercising of Your GDPR Data Protection Rights
                    </Text>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 400,
                        fontSize: 14,
                        lineHeight: '1.6em',
                        color: textColor,
                      }}
                    >
                      You may exercise Your rights of access, rectification, cancellation and
  opposition by contacting Us. Please note that we may ask You to verify Your
  identity before responding to such requests. If You make a request, We will
  try our best to respond to You as soon as possible.
<br />
<br />
You have the right to complain to a Data Protection Authority about Our
collection and use of Your Personal Data. For more information, if You are in
the European Economic Area (EEA), please contact Your local data protection
authority in the EEA.
<br />
<br />
                    </Text>
                    
                  </Stack>

                  {/* CCPA Privacy */}
                  <Stack gap={16}>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 510,
                        fontSize: 18,
                        lineHeight: '1.2em',
                        color: headingColor,
                      }}
                    >
                      CCPA Privacy
                    </Text>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 400,
                        fontSize: 14,
                        lineHeight: '1.6em',
                        color: textColor,
                      }}
                    >
                      This privacy notice section for California residents supplements the information contained in Our Privacy Policy and it applies solely to all visitors, users, and others who reside in the State of California.
                    </Text>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Categories of Personal Information Collected
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        We collect information that identifies, relates to, describes, references, is capable of being associated with, or could reasonably be linked, directly or indirectly, with a particular Consumer or Device. The following is a list of categories of personal information which we may collect or may have been collected from California residents within the last twelve (12) months.
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        Please note that the categories and examples provided in the list below are those defined in the CCPA. This does not mean that all examples of that category of personal information were in fact collected by Us, but reflects our good faith belief to the best of our knowledge that some of that information from the applicable category may be and may have been collected. For example, certain categories of personal information would only be collected if You provided such personal information directly to Us.
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                       * Category A: Identifiers.
<br />
Examples: A real name, alias, postal address, unique personal identifier,
online identifier, Internet Protocol address, email address, account name,
driver's license number, passport number, or other similar identifiers.
<br />
Collected: Yes.
<br />
* Category B: Personal information categories listed in the California
Customer Records statute (Cal. Civ. Code Â§ 1798.80(e)).
<br />

Examples: A name, signature, Social Security number, physical
characteristics or description, address, telephone number, passport
number, driver's license or state identification card number, insurance
policy number, education, employment, employment history, bank account
number, credit card number, debit card number, or any other financial
information, medical information, or health insurance information. Some
personal information included in this category may overlap with other
categories.
<br />
Collected: Yes. 
<br />
* Category C: Protected classification characteristics under California or
federal law.
<br />
Examples: Age (40 years or older), race, color, ancestry, national origin,
citizenship, religion or creed, marital status, medical condition,
physical or mental disability, sex (including gender, gender identity,
gender expression, pregnancy or childbirth and related medical
conditions), sexual orientation, veteran or military status, genetic
information (including familial genetic information).
<br />
Collected: No.

* Category D: Commercial information.
<br />
Examples: Records and history of products or services purchased or
considered.
<br />
Collected: No.

* Category E: Biometric information.
<br />
Examples: Genetic, physiological, behavioral, and biological
characteristics, or activity patterns used to extract a template or other
identifier or identifying information, such as, fingerprints, faceprints,
and voiceprints, iris or retina scans, keystroke, gait, or other physical
patterns, and sleep, health, or exercise data.
<br />
Collected: No.

* Category F: Internet or other similar network activity.
<br />
Examples: Interaction with our Service or advertisement.
<br />
Collected: Yes.
<br />
* Category G: Geolocation data.
<br />
Examples: Approximate physical location.
<br />
Collected: Yes.
<br />  
* Category H: Sensory data.
<br />    
Examples: Audio, electronic, visual, thermal, olfactory, or similar
information.
<br />
Collected: No.
<br />
* Category I: Professional or employment-related information.
<br />
Examples: Current or past job history or performance evaluations.
<br />
Collected: No.
<br />
* Category J: Non-public education information (per the Family Educational
Rights and Privacy Act (20 U.S.C. Section 1232g, 34 C.F.R. Part 99)).
<br />
Examples: Education records directly related to a student maintained by an
educational institution or party acting on its behalf, such as grades,
transcripts, class lists, student schedules, student identification codes,
student financial information, or student disciplinary records.
<br />
Collected: No.
<br />
* Category K: Inferences drawn from other personal information.
<br />
Examples: Profile reflecting a person's preferences, characteristics,
psychological trends, predispositions, behavior, attitudes, intelligence,
abilities, and aptitudes.
<br />
Collected: No.
<br />
                      </Text>
                      
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        Under CCPA, personal information does not include:
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                          * Publicly available information from government records
<br />
* Deidentified or aggregated consumer information
<br />
* Information excluded from the CCPA's scope, such as:
<br />
  * Health or medical information covered by the Health Insurance
    Portability and Accountability Act of 1996 (HIPAA) and the California
    Confidentiality of Medical Information Act (CMIA) or clinical trial data
<br />
  * Personal Information covered by certain sector-specific privacy laws,
    including the Fair Credit Reporting Act (FRCA), the Gramm-Leach-Bliley
    Act (GLBA) or California Financial Information Privacy Act (FIPA), and
    the Driver's Privacy Protection Act of 1994
<br />
<br />
                      </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Sources of Personal Information
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        We obtain the categories of personal information listed above from the following categories of sources:
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        * Directly from You. For example, from the forms You complete on our
  Service, preferences You express or provide through our Service.
<br />
* Indirectly from You. For example, from observing Your activity on our
  Service.
<br />
* Automatically from You. For example, through cookies We or our Service
  Providers set on Your Device as You navigate through our Service.
<br />
* From Service Providers. For example, or other third-party vendors that We
  use to provide the Service to You.
<br />
                      </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Use of Personal Information for Business Purposes or Commercial Purposes
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        We may use or disclose personal information We collect for "business purposes" or "commercial purposes" (as defined under the CCPA), which may include the following examples:
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        * To operate our Service and provide You with our Service.
<br />
* To provide You with support and to respond to Your inquiries, including to
  investigate and address Your concerns and monitor and improve our Service.
<br />
* To fulfill or meet the reason You provided the information. For example,
  if You share Your contact information to ask a question about our Service,
  We will use that personal information to respond to Your inquiry.
<br />
* To respond to law enforcement requests and as required by applicable law,
  court order, or governmental regulations.
<br />
* As described to You when collecting Your personal information or as
  otherwise set forth in the CCPA.
<br />
* For internal administrative and auditing purposes.
<br />
* To detect security incidents and protect against malicious, deceptive,
  fraudulent or illegal activity, including, when necessary, to prosecute
  those responsible for such activities.
<br />
</Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        Please note that the examples provided above are illustrative and not intended to be exhaustive. For more details on how we use this information, please refer to the "Use of Your Personal Data" section.
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        If We decide to collect additional categories of personal information or use the personal information We collected for materially different, unrelated, or incompatible purposes We will update this Privacy Policy.
                      </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Disclosure of Personal Information for Business Purposes or Commercial Purposes
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        We may use or disclose and may have used or disclosed in the last twelve (12) months the following categories of personal information for business or commercial purposes:
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                      * Category A: Identifiers
<br />
* Category B: Personal information categories listed in the California
Customer Records statute (Cal. Civ. Code Â§ 1798.80(e))
<br />

* Category F: Internet or other similar network activity
<br />
* Category G: Geolocation data
<br />
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        Please note that the categories listed above are those defined in the CCPA. This does not mean that all examples of that category of personal information were in fact disclosed, but reflects our good faith belief to the best of our knowledge that some of that information from the applicable category may be and may have been disclosed.
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        When We disclose personal information for a business purpose or a commercial
purpose, We enter a contract that describes the purpose and requires the
recipient to both keep that personal information confidential and not use it
for any purpose except performing the contract.  
<br />
<br />
                    </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Sale of Personal Information
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        As defined in the CCPA, "sell" and "sale" mean selling, renting, releasing,
disclosing, disseminating, making available, transferring, or otherwise
communicating orally, in writing, or by electronic or other means, a
consumer's personal information by the business to a third party for valuable
consideration. This means that We may have received some kind of benefit in
return for sharing personal Iinformation, but not necessarily a monetary
benefit.
<br />
<br />
Please note that the categories listed below are those defined in the CCPA.
This does not mean that all examples of that category of personal information
were in fact sold, but reflects our good faith belief to the best of our
knowledge that some of that information from the applicable category may be
and may have been shared for value in return.
<br />
<br />
                      </Text>
                      
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        We may sell and may have sold in the last twelve (12) months the following categories of personal information:
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                         * Category A: Identifiers
<br />
* Category B: Personal information categories listed in the California
Customer Records statute (Cal. Civ. Code Â§ 1798.80(e))
<br />
* Category F: Internet or other similar network activity
<br />
* Category G: Geolocation data
<br />
                      </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Share of Personal Information
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        We may share Your personal information identified in the above categories with the following categories of third parties:
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        * Service Providers
<br />
* Our affiliates
<br />
* Our business partners
<br />

<br />
* Third party vendors to whom You or Your agents authorize Us to disclose
Your personal information in connection with products or services We
provide to You
<br />

                      </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Sale of Personal Information of Minors Under 16 Years of Age
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        We do not sell the personal information of Consumers We actually know are less
than 16 years of age, unless We receive affirmative authorization (the "right
to opt-in") from either the Consumer who is between 13 and 16 years of age, or
the parent or guardian of a Consumer less than 13 years of age. Consumers who
opt-in to the sale of personal information may opt-out of future sales at any
time. To exercise the right to opt-out, You (or Your authorized
representative) may submit a request to Us by contacting Us.                        </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
If You have reason to believe that a child under the age of 13 (or 16) has
provided Us with personal information, please contact Us with sufficient
detail to enable Us to delete that information.
                      </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Your Rights under the CCPA
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        The CCPA provides California residents with specific rights regarding their personal information. If You are a resident of California, You have the following rights:
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        * The right to notice. You have the right to be notified which categories of
  Personal Data are being collected and the purposes for which the Personal
  Data is being used.
<br />
* The right to request. Under CCPA, You have the right to request that We
  disclose information to You about Our collection, use, sale, disclosure
  for business purposes and share of personal information. Once We receive
  and confirm Your request, We will disclose to You:
<br />
  * The categories of personal information We collected about You
<br />
  * The categories of sources for the personal information We collected
    about You
<br />
  * Our business or commercial purpose for collecting or selling that
    personal information
<br />
  * The categories of third parties with whom We share that personal
    information
<br />
  * The specific pieces of personal information We collected about You
<br />
  * If we sold Your personal information or disclosed Your personal
    information for a business purpose, We will disclose to You:
<br />
    * The categories of personal information categories sold
<br />
    * The categories of personal information categories disclosed
<br />
* The right to say no to the sale of Personal Data (opt-out). You have the
  right to direct Us to not sell Your personal information. To submit an
  opt-out request please contact Us.
<br />
* The right to delete Personal Data. You have the right to request the
  deletion of Your Personal Data, subject to certain exceptions. Once We
  receive and confirm Your request, We will delete (and direct Our Service
  Providers to delete) Your personal information from our records, unless an
  exception applies. We may deny Your deletion request if retaining the
  information is necessary for Us or Our Service Providers to:
<br />
  * Complete the transaction for which We collected the personal
    information, provide a good or service that You requested, take actions
    reasonably anticipated within the context of our ongoing business
    relationship with You, or otherwise perform our contract with You.
<br />
  * Detect security incidents, protect against malicious, deceptive,
    fraudulent, or illegal activity, or prosecute those responsible for such
    activities.
<br />
  * Debug products to identify and repair errors that impair existing
    intended functionality.
<br />
  * Exercise free speech, ensure the right of another consumer to exercise
    their free speech rights, or exercise another right provided for by law.
<br />
  * Comply with the California Electronic Communications Privacy Act (Cal.
    Penal Code Â§ 1546 et. seq.).
<br />
  * Engage in public or peer-reviewed scientific, historical, or statistical
    research in the public interest that adheres to all other applicable
    ethics and privacy laws, when the information's deletion may likely
    render impossible or seriously impair the research's achievement, if You
    previously provided informed consent.
<br />
  * Enable solely internal uses that are reasonably aligned with consumer
    expectations based on Your relationship with Us.
<br />
  * Comply with a legal obligation.
<br />
  * Make other internal and lawful uses of that information that are
    compatible with the context in which You provided it.
<br />
* The right not to be discriminated against. You have the right not to be
  discriminated against for exercising any of Your consumer's rights,
  including by:
  <br />
  * Denying goods or services to You
  <br />
  * Charging different prices or rates for goods or services, including the
    use of discounts or other benefits or imposing penalties
  <br />
  * Providing a different level or quality of goods or services to You
  <br />
  * Suggesting that You will receive a different price or rate for goods or
    services or a different level or quality of goods or services
  <br />
</Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Exercising Your CCPA Data Protection Rights
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        In order to exercise any of Your rights under the CCPA, and if You are a California resident, You can contact Us:
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                         * By visiting this page on our website: contact@oneself.com
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        Only You, or a person registered with the California Secretary of State that
You authorize to act on Your behalf, may make a verifiable request related to
Your personal information.                        </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        Your request to Us must:
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        * Provide sufficient information that allows Us to reasonably verify You are
  the person about whom We collected personal information or an authorized
  representative
<br />
* Describe Your request with sufficient detail that allows Us to properly
  understand, evaluate, and respond to it
<br />
</Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        We cannot respond to Your request or provide You with the required information if we cannot:
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                         * Verify Your identity or authority to make the request
                         <br />
                         * And confirm that the personal information relates to You
                         <br />
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        We will disclose and deliver the required information free of charge within 45
days of receiving Your verifiable request. The time period to provide the
required information may be extended once by an additional 45 days when
reasonable necessary and with prior notice.                        </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
Any disclosures We provide will only cover the 12-month period preceding the
verifiable request's receipt.                        </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
For data portability requests, We will select a format to provide Your
personal information that is readily useable and should allow You to transmit
the information from one entity to another entity without hindrance.                        </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Do Not Sell My Personal Information
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
You have the right to opt-out of the sale of Your personal information. Once
We receive and confirm a verifiable consumer request from You, we will stop
selling Your personal information. To exercise Your right to opt-out, please
contact Us.                        </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        "Do Not"Do Not Track" Policy as Required by California Online Privacy Protection Act
                        (CalOPPA)  Track" Policy as Required by California Online Privacy Protection Act (CalOPPA)
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        Our Service does not respond to Do Not Track signals.
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
However, some third party websites do keep track of Your browsing activities.
If You are visiting such websites, You can set Your preferences in Your web
browser to inform websites that You do not want to be tracked. You can enable
or disable DNT by visiting the preferences or settings page of Your web
browser.                        </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        Your California Privacy Rights (California's Shine the Light law)
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
Under California Civil Code Section 1798 (California's Shine the Light law),
California residents with an established business relationship with us can
request information once a year about sharing their Personal Data with third
parties for the third parties' direct marketing purposes.                        </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
If you'd like to request more information under the California Shine the Light
law, and if You are a California resident, You can contact Us using the
contact information provided below.                        </Text>
                    </Stack>

                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 510,
                          fontSize: 16,
                          lineHeight: '1.2em',
                          color: headingColor,
                        }}
                      >
                        California Privacy Rights for Minor Users (California Business and Professions Code Section 22581)
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
California Business and Professions Code section 22581 allow California
residents under the age of 18 who are registered users of online sites,
services or applications to request and obtain removal of content or
information they have publicly posted.
<br />
<br />
</Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
To request removal of such data, and if You are a California resident, You can
contact Us using the contact information provided below, and include the email
address associated with Your account. 
<br />
<br />
                     </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
Be aware that Your request does not guarantee complete or comprehensive
removal of content or information posted online and that the law may not
permit or require removal in certain circumstances.
<br />
<br />
</Text>
                    </Stack>
                  </Stack>

                  {/* Links to Other Websites */}
                  <Stack gap={16}>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 510,
                        fontSize: 18,
                        lineHeight: '1.2em',
                        color: headingColor,
                      }}
                    >
                      Links to Other Websites
                      <br />
                      <br />
                    </Text>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 400,
                        fontSize: 14,
                        lineHeight: '1.6em',
                        color: textColor,
                      }}
                    >
Our Service may contain links to other websites that are not operated by Us.
If You click on a third party link, You will be directed to that third party's
site. We strongly advise You to review the Privacy Policy of every site You
visit.
<br />
<br />
</Text>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 400,
                        fontSize: 14,
                        lineHeight: '1.6em',
                        color: textColor,
                      }}
                    >
We have no control over and assume no responsibility for the content, privacy
policies or practices of any third party sites or services.     
<br />
<br />
</Text>
                  </Stack>

                  {/* Changes to this Privacy Policy */}
                  <Stack gap={16}>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 510,
                        fontSize: 18,
                        lineHeight: '1.2em',
                        color: headingColor,
                      }}
                    >
                      Changes to this Privacy Policy
                      <br />
                      <br />
                    </Text>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 400,
                        fontSize: 14,
                        lineHeight: '1.6em',
                        color: textColor,
                      }}
                    >
We may update Our Privacy Policy from time to time. We will notify You of any
changes by posting the new Privacy Policy on this page.      
<br />
<br />
</Text>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 400,
                        fontSize: 14,
                        lineHeight: '1.6em',
                        color: textColor,
                      }}
                    >
We will let You know via email and/or a prominent notice on Our Service, prior
to the change becoming effective and update the "Last updated" date at the top
of this Privacy Policy.     
<br />
<br />
</Text>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 400,
                        fontSize: 14,
                        lineHeight: '1.6em',
                        color: textColor,
                      }}
                    >
You are advised to review this Privacy Policy periodically for any changes.
Changes to this Privacy Policy are effective when they are posted on this
page.
<br />
<br />
</Text>
                  </Stack>

                  {/* Contact Us */}
                  <Divider color="#E9E9E9" />
                  <Stack gap={16}>
                    <Text
                      style={{
                        fontFamily: 'SF Pro',
                        fontWeight: 510,
                        fontSize: 16,
                        lineHeight: '1.2em',
                        color: headingColor,
                      }}
                    >
                      Contact Us
                      <br />
                    </Text>
                    <Stack gap={8}>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
                        If you have any questions about this Privacy Policy, You can contact us:
                        <br />
                      </Text>
                      <Text
                        style={{
                          fontFamily: 'SF Pro',
                          fontWeight: 400,
                          fontSize: 14,
                          lineHeight: '1.6em',
                          color: textColor,
                        }}
                      >
* By visiting this page on our website:
[contact@oneself.com](contact@oneself.com)    
<br />
</Text>
                    </Stack>
                  </Stack>
                </Stack>
            </Stack>
  );
}

